// extracted by mini-css-extract-plugin
export default {"ProfilePerson":"ProfilePerson_ProfilePerson__Z5AJR"};